export default [
  {
    path: 'help',
    name: 'help',
    component: () => import('./ListHelpPage.vue')
  }
]
